import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { register } from 'register-service-worker'; // The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

var log = process.env.DEV;
register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter
  // registrationOptions: { scope: './' },
  ready: function ready() {
    if (log) {
      console.log('App is being served from cache by a service worker.');
    }
  },
  registered: function registered(registration) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var status;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setInterval(function () {
                registration.update();
              }, 1000 * 60 * 2); // 2 min checks

              if (log) {
                console.log('Service worker has been registered.');
              } // Set up Periodic sync for downloading app settings


              if (!('periodicSync' in registration)) {
                _context.next = 14;
                break;
              }

              _context.next = 5;
              return navigator.permissions.query({
                name: 'periodic-background-sync'
              });

            case 5:
              status = _context.sent;

              if (!(status.state === 'granted')) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return registration.periodicSync.register('download-app-settings', {
                minInterval: 24 * 60 * 60 * 1000 // 1 day

              });

            case 9:
              _context.next = 12;
              break;

            case 11:
              if (log) {
                console.log('Permission denied');
              }

            case 12:
              _context.next = 15;
              break;

            case 14:
              if (log) {
                console.log('No periodicSync available');
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  cached: function cached() {
    if (log) {
      console.log('Content has been cached for offline use.');
    }
  },
  updatefound: function updatefound() {
    if (log) {
      console.log('New content is downloading.');
    }
  },
  updated: function updated(registration) {
    document.dispatchEvent(new CustomEvent('swUpdated', {
      detail: registration
    }));

    if (log) {
      console.log('New content is available; please refresh.');
    }
  },
  offline: function offline() {
    if (log) {
      console.log('No internet connection found. App is running in offline mode.');
    }
  },
  error: function error(err) {
    if (log) {
      console.error('Error during service worker registration:', err);
    }
  }
});